import React from 'react';

type Props = {
  x: number;
  y: number;
  width: number;
  height: number;
  onClick: () => void;
};

// 透明なクリック領域をSVG上に配置
const ClickArea: React.FC<Props> = (props) => {
  return (
    <g>
      <rect {...props} opacity={0} cursor='pointer'></rect>
    </g>
  );
};

export default React.memo(ClickArea);
